export enum AppUrl {
  AU = 'app.bluebeam.com.au',
  DE = 'app.bluebeam.de',
  SE = 'app.bluebeam.se',
  UK = 'app.bluebeam.co.uk',
  US = 'app.bluebeam.com',
  DEV = 'app.bluebeam-dev.com',
  QA = 'app.bluebeam-qa.com',
}
